/** The picture of a quick live: its poster, else the faces of who came, else a calm tile with the title's initials. */
import type { RoomFace } from "../../../shared/types";
import { FaceStack, initialsOf } from "../../components/ui/Face";

interface Props {
  poster: string | null;
  title: string;
  faces: readonly RoomFace[];
}

export function LivePicture({ poster, title, faces }: Props) {
  const photos = faces.filter((f) => f.avatar_url).slice(0, 4);
  if (poster) {
    return (
      <span className="lp">
        <img className="lp-bg" src={poster} alt="" />
        {photos.length > 0 ? <FaceStack className="lp-faces" people={photos.map((f) => ({ name: f.name, photo: f.avatar_url }))} size={30} /> : null}
      </span>
    );
  }
  if (photos.length > 0) {
    return (
      <span className="lp lp-grid" data-n={photos.length}>
        {photos.map((f) => (
          <img key={f.registrantId} src={f.avatar_url ?? undefined} alt="" />
        ))}
      </span>
    );
  }
  if (faces.length > 0) {
    return (
      <span className="lp lp-tile">
        <FaceStack people={faces.slice(0, 4).map((f) => ({ name: f.name }))} size={52} />
      </span>
    );
  }
  return (
    <span className="lp lp-tile lp-brand">
      <b className="lp-ini">{initialsOf(title) || "F"}</b>
    </span>
  );
}
